import React from 'react';
import { AuthenticatedTemplate, useIsAuthenticated } from '@azure/msal-react';
import { Title, StyledBackButton } from './styled';
import Export from './export/Export';
import { StyledHeader, StyledProfile } from '@med-fe/ui';
import { useSelector } from 'react-redux';
import { getIsAccessDenied } from '../../store/user/user-reducer';
import { getCurrentWeekRange } from '../../common/helpers/date';
import NavbarMenu from '../navbar/NavbarMenu';
import { routes } from '../../App';
import { useHistory, useLocation } from 'react-router-dom';
import { isEqual, upperCase } from 'lodash';
import { Adjustment } from './adjustment/Adjustment';
import styles from './header.module.scss';

export default function Header() {
  const isAuthenticated = useIsAuthenticated();
  const isAccessDenied = useSelector(getIsAccessDenied);
  const { pathname } = useLocation();
  const history = useHistory();

  return (
    <StyledHeader isAuthenticated={isAuthenticated}>
      <AuthenticatedTemplate>
        {!isAccessDenied && (
          <>
            <NavbarMenu routes={routes} />
            <Title style={{ padding: '12px 0' }}>
              {isEqual(pathname, '/templates-assignment') &&
                upperCase(`Open slots for the month of ${getCurrentWeekRange()}`)}
              {isEqual(pathname, '/templates-management') && upperCase('Template Management')}
              {isEqual(pathname, '/exception-management') && upperCase('Exception Management')}
              {isEqual(pathname, '/schedule-ramps') && upperCase('Schedule Ramps')}
              {isEqual(pathname, '/template-viewer') && upperCase('Template Viewer')}
              {pathname.includes('/template-viewer/details') && (
                <StyledBackButton
                  type={'link'}
                  onClick={() =>
                    history.push({
                      pathname: '/template-viewer',
                      state: (history.location as any).state,
                    })
                  }
                >
                  <img alt='back' src={'./icons/back.svg'} />
                  <span>{'TEMPLATE VIEWER (READ ONLY)'}</span>
                </StyledBackButton>
              )}
              {(pathname.includes('/templates-management/details') ||
                pathname.includes('/templates-management/clone') ||
                pathname.includes('/templates-management/draftdetails')) && (
                <StyledBackButton type={'link'} onClick={() => history.push(`/templates-management`)}>
                  <img alt='back' src={'./icons/back.svg'} />
                  <span>{upperCase('Template Management')}</span>
                </StyledBackButton>
              )}
              {pathname.includes('/liveranges-management/details') && (
                <StyledBackButton type={'link'} onClick={() => history.push(`/templates-assignment?tab=liveRanges`)}>
                  <img alt='back' src={'./icons/back.svg'} />
                  <span>{upperCase('Live Ranges Management')}</span>
                </StyledBackButton>
              )}
              {isEqual(pathname, '/resource-cleanup') && upperCase('Resource Cleanup')}
              {isEqual(pathname, '/templates-accommodations') && upperCase('Templates Accommodations')}
            </Title>
            {!pathname.includes('templates-accommodations') && <Export />}
            <Adjustment />
          </>
        )}
      </AuthenticatedTemplate>
      {isAuthenticated && <StyledProfile />}
      <div className={styles.headerTitle}>
        <span className={styles.headerTitle__pace}>P</span>
        <span className={styles.headerTitle__pace}>A</span>
        <span className={styles.headerTitle__pace}>C</span>
        <span className={styles.headerTitle__pace}>E</span>
      </div>
    </StyledHeader>
  );
}
